import { GlobalsPrototype, createGlobalsFromJsonScript } from '../../../default/global/js/globals-prototype.js';

window.GlobalsPrototype = GlobalsPrototype;
window.GLOBALS = createGlobalsFromJsonScript();
